import React from "react";
import { Main } from "@/components/main";
import { Toaster } from "@/components/ui/toaster";

export const App = () => {
  const primaryColor =
    process.env.NAME === "smilealigners" ? `10 29% 39%` : `4 74% 53%`;
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            :root {
              --primary: ${primaryColor};
            }
        `,
        }}
      ></style>
      <div className="container py-5">
        <Main />
        <Toaster />
      </div>
    </>
  );
};
